export const PRIMARY_BUTTON_PRESETS_COUNT = 2;
export const SECONDARY_BUTTON_PRESETS_COUNT = 6;

const buttonPresetSectionIds = {
  PRIMARY_BUTTON: 'primary-button',
  SECONDARY_BUTTON: 'secondary-button',
};

export default buttonPresetSectionIds;
